// Function to get UTM parameters from URL
function getUtmParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
    if (urlParams.has(param)) {
      utmParams[param] = urlParams.get(param);
    }
  });
  return utmParams;
}

// Function to add UTM parameters to a URL
function addUtmToUrl(url, utmParams) {
  const urlObj = new URL(url);
  Object.entries(utmParams).forEach(([key, value]) => {
    urlObj.searchParams.append(key, value);
  });
  return urlObj.toString();
}

// Main function to update the button's href
function updateButtonHref() {
  const button = document.querySelector('a.button-contrast.btn-full-hover');
  if (button) {
    const currentHref = button.getAttribute('href');
    const utmParams = getUtmParams();
    const newHref = addUtmToUrl(currentHref, utmParams);
    button.setAttribute('href', newHref);
  }
}

// Run the script when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', updateButtonHref);